import {css} from 'lit';

export default css`
  :host([hidden]) {
    display: none;
  }
`;
